import { useTranslation } from 'react-i18next';

import FormFieldset from '@/components/atoms/Fieldset/templates/FormFieldset';
import { ReadOnlyField } from '@/components/atoms/ReadOnlyField/ReadOnlyField';
import { InfobipRcsIntegration } from '@/shared/types/integration';

interface Props {
  integration: InfobipRcsIntegration;
}

/**
 * InfobipRcs integration information panel using FormFieldset.
 *
 * Displays configuration details for the Infobip RCS integration as read-only fields.
 * This component is shown when the integration is connected and configured.
 */
export function InfobipRcsInfo({ integration }: Props) {
  const { t } = useTranslation();

  return (
    <FormFieldset
      title={t('integrations.infobip_rcs_info.overview')}
      subtitle={t('integrations.infobip_rcs_info.subtitle')}
      primaryButton={{
        children: t('common.save'),
        disabled: true, // Always disabled since fields are read-only
      }}
      onSubmit={() => {}}
    >
      <div className="space-y-6">
        <ReadOnlyField
          label={t('integrations.infobip_rcs_info.apikey')}
          value={integration.config.apikey}
        />
        <ReadOnlyField
          label={t('integrations.infobip_rcs_info.base_url')}
          value={integration.config.base_url}
        />
        <ReadOnlyField
          label={t('integrations.infobip_rcs_info.sender_name')}
          value={integration.config.sender_name}
        />
        <ReadOnlyField
          label={t('integrations.infobip_rcs_info.webhook_secret')}
          value={integration.config.webhook_secret}
        />
      </div>
    </FormFieldset>
  );
}

export default InfobipRcsInfo;
